function decodeComponentUrlRaw (url) {
  if (!url) return ''
  let result = String(url)
  for (let i = 0; i < 5; i++) {
    try {
      const decoded = decodeURIComponent(result)
      if (decoded === result) break
      result = decoded
    } catch (e) {
      break
    }
  }
  return result
}

function decodeComponentUrl (url) {
  return decodeComponentUrlRaw(url).replace(/&/g, '；')
}

function encodeComponentUrl (url) {
  if (!url) return ''
  return decodeComponentUrlRaw(url).replace(/&/g, '；')
}

function toNumber (value, fallback) {
  const num = Number(value)
  return Number.isFinite(num) ? num : fallback
}

function pickEditorStyle (style) {
  if (!style || typeof style !== 'object') {
    return { x: 0, y: 0, width: 90, height: 90, scaleX: 1, scaleY: 1 }
  }
  const next = {
    x: Math.round(toNumber(style.x, 0)),
    y: Math.round(toNumber(style.y, 0)),
    width: toNumber(style.width, 90),
    height: toNumber(style.height, 90),
    scaleX: style.scaleX === undefined ? 1 : toNumber(style.scaleX, 1),
    scaleY: style.scaleY === undefined ? 1 : toNumber(style.scaleY, 1)
  }
  if (style.id !== undefined && style.id !== null) next.id = style.id
  return next
}

function normalizeAssetUrl (url) {
  if (!url) return ''
  return String(url).replace(/^http:\/\/p\.cldisk\.com/i, 'https://p.cldisk.com')
}

function sanitizeImageList (image) {
  if (!Array.isArray(image)) return []
  return image.filter(item => item && item.fileUrl).map(item => ({
    ...item,
    fileUrl: normalizeAssetUrl(item.fileUrl)
  }))
}

function sanitizeNode (node, decodeUrl) {
  if (!node || typeof node !== 'object') return node
  const data = node.data && typeof node.data === 'object' ? { ...node.data } : {}
  if (data.url) {
    data.url = decodeUrl ? decodeComponentUrl(data.url) : encodeComponentUrl(data.url)
  }
  const next = {
    id: node.id,
    type: node.type || 'Image',
    flag: node.flag || false,
    style: pickEditorStyle(node.style),
    image: sanitizeImageList(node.image),
    data
  }
  if (next.style && next.id !== undefined && next.id !== null) next.style.id = next.id
  return next
}

function sanitizeList (list, decodeUrl) {
  if (!Array.isArray(list)) return []
  return list.map(item => sanitizeNode(item, decodeUrl)).filter(Boolean)
}

function stripHtmlWrap (raw) {
  if (raw == null) return ''
  return String(raw).replace(/(<\/?p.*?>)/gi, '')
}

function parseComponentEditorData (raw, fallbackSize) {
  let data = raw
  if (typeof raw === 'string') {
    const text = stripHtmlWrap(raw)
    if (!text) {
      data = {}
    } else {
      try {
        data = JSON.parse(text)
      } catch (e) {
        data = {}
      }
    }
  }
  if (!data || typeof data !== 'object') data = {}
  const fallbackWidth = fallbackSize && fallbackSize.width ? fallbackSize.width : 0
  const fallbackHeight = fallbackSize && fallbackSize.height ? fallbackSize.height : 0
  return {
    List: sanitizeList(data.List, true),
    appList: sanitizeList(data.appList, true),
    pcwidth: data.pcwidth ? toNumber(data.pcwidth, fallbackWidth) : fallbackWidth,
    pcheight: data.pcheight ? toNumber(data.pcheight, fallbackHeight) : fallbackHeight
  }
}

function normalizeComponentNodeForSave (node) {
  if (!node || node.type !== 'Image') return sanitizeNode(node, false)
  const style = pickEditorStyle(node.style)
  const scaleX = style.scaleX === undefined ? 1 : style.scaleX
  const scaleY = style.scaleY === undefined ? 1 : style.scaleY
  return sanitizeNode({
    ...node,
    style: {
      ...style,
      width: Math.round(style.width * scaleX),
      height: Math.round(style.height * scaleY),
      scaleX: 1,
      scaleY: 1
    }
  }, false)
}

function serializeComponentEditorData (editorData, fallbackSize) {
  const source = editorData && typeof editorData === 'object' ? editorData : {}
  const fallbackWidth = fallbackSize && fallbackSize.width ? fallbackSize.width : 0
  const fallbackHeight = fallbackSize && fallbackSize.height ? fallbackSize.height : 0
  return {
    List: (Array.isArray(source.List) ? source.List : []).map(normalizeComponentNodeForSave),
    appList: (Array.isArray(source.appList) ? source.appList : []).map(normalizeComponentNodeForSave),
    pcwidth: source.pcwidth ? toNumber(source.pcwidth, fallbackWidth) : fallbackWidth,
    pcheight: source.pcheight ? toNumber(source.pcheight, fallbackHeight) : fallbackHeight
  }
}

function replaceEditorNodeById (list, node) {
  const source = Array.isArray(list) ? list : []
  if (!node) return source
  return source.map(item => String(item.id) === String(node.id) ? node : item)
}

function ensureEditorLists (editorData) {
  const source = editorData && typeof editorData === 'object' ? editorData : {}
  return {
    List: Array.isArray(source.List) ? source.List : [],
    appList: Array.isArray(source.appList) ? source.appList : [],
    pcwidth: source.pcwidth || 0,
    pcheight: source.pcheight || 0
  }
}

module.exports = {
  pickEditorStyle,
  normalizeAssetUrl,
  parseComponentEditorData,
  serializeComponentEditorData,
  normalizeComponentNodeForSave,
  replaceEditorNodeById,
  ensureEditorLists
}
